const SUPER_DEALS_CATEGORY_LABELS = {
  all: "All",
  attractions: "Attractions",
  flights: "Flights",
  hotels: "Hotels",
  "indian-escapes-deals": "Indian Escapes Deals",
  "international-getaway-deals": "International Getaway Deals",
};

export function normalizeSuperDealsCategorySlug(value = "") {
  const cleaned = String(value || "")
    .trim()
    .replace(/\+/g, " ");
  if (!cleaned) return "";
  let decoded = cleaned;
  try {
    decoded = decodeURIComponent(cleaned);
  } catch {
    decoded = cleaned;
  }
  return decoded
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function superDealsCategoryLabelFromSlug(value = "") {
  const slug = normalizeSuperDealsCategorySlug(value);
  return SUPER_DEALS_CATEGORY_LABELS[slug] || "";
}

export function superDealsCategorySlugFromLabel(value = "") {
  const label = String(value || "").trim();
  if (!label || label === "All") return "";
  const normalizedLabel = label.toLowerCase();
  const directMatch = Object.entries(SUPER_DEALS_CATEGORY_LABELS).find(([, mappedLabel]) => mappedLabel.toLowerCase() === normalizedLabel);
  if (directMatch) return directMatch[0] === "all" ? "" : directMatch[0];
  return normalizeSuperDealsCategorySlug(label);
}

